
export const addFavorite = (payload) => {
    return {
        type: 'ADD_FAVORITE',
        payload
    }
}

export const setMovies = (payload) => {
    return {
        type: 'ADD_NOW_PLAYING_MOVIES',
        payload
    }
}

export const setSearchMovies = (payload) => {
    return {
        type: 'SEARCH_RESULTS_MOVIES',
        payload
    }
}

export const setError = (payload) => {
    return {
        type: 'ERROR',
        payload
    }
}

export const setLoading = (payload) => {
    return {
        type: 'LOADING',
        payload
    }
}

export const setQuery = (payload) => {
    return {
        type: 'QUERY',
        payload
    }
}

export const changeQuery = (payload) => {
    return {
        type: 'CHANGE_QUERY',
        payload
    }
}

export const getMoviesNow = () => {
    return (dispatch) => {
        fetch(`https://api.themoviedb.org/3/movie/now_playing?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&page=1`)
            .then((response) => response.json())
            .then((movieNowData) => {
                dispatch(setMovies(movieNowData.results))
            })
            .catch((err) => {
                dispatch(setError(err))
            })
            .finally(() => {
                dispatch(setLoading(false))
            })
        }
}

export const getSearchResult = (query) => {
    return (dispatch) => {
        fetch(`https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&query=${query}&page=1&include_adult=false`)
            .then((response) => response.json())
            .then((movieSearch) => {
                dispatch(setSearchMovies(movieSearch.results))
            })
            .catch((err) => {
                dispatch(setError(err))
            })
            .finally(() => {
                dispatch(setLoading(false))
            })
        }
}